import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '@Core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'ep-address-select-dialog',
    templateUrl: './address-select-dialog.component.html'
})
export class AddressSelectDialogComponent {
    @Input() addresses: any[];

    constructor(private activeModal: NgbActiveModal, public app: AppService) { }

    public onSelect(address: {}) {
        this.activeModal.close(address);
    }

    public cancelSelection() {
        this.activeModal.close();
    }
}
